import $api from "@/api/index";

export type HexagonPriceEdaUpdate = {
  id: number;
  price: number;
};

export async function updateHexagonsPriceEdaBatch(
  kind: "car" | "velo",
  updates: HexagonPriceEdaUpdate[]
) {
  await $api.patch(`/v2/hexagons/price-eda/${kind}`, updates);
}

export async function copyCarPriceEdaToVelo() {
  await $api.post("/v2/hexagons/price-eda/copy-car-to-velo");
}

export async function createEditorZone(params: {
  hexgroup_id: number;
  hexagon_ids: number[];
}) {
  const { data } = await $api.post<{ id: number }>("/v2/editor-zones", params);
  return data;
}

export async function updateEditorZoneHexagons(
  zoneId: number,
  hexagonIds: number[]
) {
  await $api.put(`/v2/editor-zones/${zoneId}/hexagons`, {
    hexagon_ids: hexagonIds,
  });
}

export async function deleteEditorZone(zoneId: number) {
  await $api.delete(`/v2/editor-zones/${zoneId}`);
}
